import React from "react";
import { Checkbox, FormControlLabel, SvgIcon } from "@mui/material";
import { mdiCheckboxMarked } from "@mdi/js";
import PropTypes from "prop-types";

const formControlLabelStyle = {
	alignItems: "center",
	"& .MuiFormControlLabel-label": {
		display: "flex",
		textAlign: "left",
		fontWeight: 500,
		fontSize: "12px",
		lineHeight: "24px",
		fontFamily: "Roboto",
		letterSpacing: "0px",
		color: "#FFFFFF",
		opacity: 1,
		alignItems: "center"
	}
};

const CBCheckboxWithLabel = ({ checked, onChange, label, sx, ...rest }) => {
	return (
		<FormControlLabel
			control={
				<Checkbox
					checkedIcon={
						<SvgIcon
							style={{
								width: "24px",
								height: "24px",
								color: "#4DB5F4",
								transform: "scale(0.9)"
							}}
						>
							<path d={mdiCheckboxMarked} />
						</SvgIcon>
					}
					onChange={onChange}
					checked={checked} data-testid="orion-components-cbcomponents-cbcheckbox-with-label-cbcheckbox-with-label-checkbox"
				/>
			}
			sx={{ ...formControlLabelStyle, ...sx }}
			label={label}
			{...rest}
		/>
	);
};

CBCheckboxWithLabel.propTypes = {
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.node.isRequired,
	sx: PropTypes.object
};

CBCheckboxWithLabel.defaultProps = {
	sx: {}
};

export default CBCheckboxWithLabel;
